import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('sap-configuration/sap-sync-master?page=' + page, {params});
    },
    show(id) {
        return Service().get('sap-configuration/sap-sync-master/show/'+id);
    },    
    create(params) {
        return Service().post('sap-configuration/sap-sync-master/create', params);
    },
    update(id, params) {
        return Service().post('sap-configuration/sap-sync-master/update/'+id, params);
    },
    delete(id) {
        return Service().post('sap-configuration/sap-sync-master/delete/'+id);
    }
}